module.exports = __webpack_public_path__ + "static/media/rubicscube2_1920x1080.ba6112fe.png";